import { GalaxyDateDefault } from '../enums';
import { DateOption } from './date-filter-input';

export const dateDefaultToLabel: DateOption[] = [
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_INVALID,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.INVALID',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_TODAY,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.TODAY',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_TOMORROW,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.TOMORROW',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_YESTERDAY,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.YESTERDAY',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_THIS_WEEK,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.THIS_WEEK',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_NEXT_WEEK,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.NEXT_WEEK',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_LAST_WEEK,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.LAST_WEEK',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_THIS_MONTH,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.THIS_MONTH',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_NEXT_MONTH,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.NEXT_MONTH',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_LAST_MONTH,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.LAST_MONTH',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_THIS_QUARTER,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.THIS_QUARTER',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_NEXT_QUARTER,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.NEXT_QUARTER',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_LAST_QUARTER,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.LAST_QUARTER',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_THIS_YEAR,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.THIS_YEAR',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_NEXT_YEAR,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.NEXT_YEAR',
  },
  {
    dateOption: GalaxyDateDefault.DATE_DEFAULT_LAST_YEAR,
    label: 'GALAXY.FILTER.CHIP.DATE_DEFAULT.LAST_YEAR',
  },
];
